import styled from 'styled-components'

import { Typography } from '@material-ui/core'

import fonts from '@galo-monitor/styles/fonts'

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 8px 16px;
`

export const SubheaderContainer = styled.div`
  padding: 0 0 20px 20px;

  & > div {
    margin: 5px 0;
    font-size: ${ fonts.fontSize.SS }px;
  }
`

export const TextBold = styled(Typography)`
  font-weight: ${ fonts.fontWeight.bold };
`
